import _ from "ramda/es/__";
import _mathMod from "ramda/es/mathMod";
import _take from "ramda/es/take";
import _pipe from "ramda/es/pipe";
import parseInt10 from './parseInt10';
import onlyDigits from './onlyDigits';
export default _pipe(onlyDigits, _take(10), parseInt10, _mathMod(_, 97) // eslint-disable-line no-underscore-dangle
);